import axios from 'axios';
import { API_PATH } from '../../../constants';
import { operations as absenceRequestOperations } from '../absence-requests';
import { operations as dutyExchangeOperations } from '../duty-exchanges';
import { operations as dutyRequestOperations } from '../duty-requests';
import { operations as extraWorkRequestOperations } from '../extra-work-requests';
import { actions as dutyExchangeActions } from '../duty-exchanges';
import { actions as dutyRequestActions } from '../duty-requests';
import moment from 'moment';

const fetch =
  ({ startTime, endTime, forceFetch = false, params = {}, ids }) =>
  dispatch => {
    if (startTime) startTime = moment(startTime).format();
    if (endTime) endTime = moment(endTime).format();

    params = {
      ...params,
      start_time: startTime,
      end_time: endTime
    };

    // API metadata operation arguments:
    const args = { params, forceFetch, ids };

    dispatch(absenceRequestOperations.fetch(args));
    dispatch(dutyExchangeOperations.fetch(args));
    dispatch(dutyRequestOperations.fetch(args));
    dispatch(extraWorkRequestOperations.fetch(args));
  };

const respondToTransaction = (transaction, response, ignore_schedule_warnings) => dispatch => {
  const url = `${API_PATH}/${transaction.type}s/${transaction.id}/responses/`;
  const actions = {
    duty_request: dutyRequestActions,
    duty_exchange: dutyExchangeActions
  }[transaction.type];

  if (!actions) throw new Error(`Actions not found for ${transaction}`);

  const data = { response, ignore_schedule_warnings };
  return axios.post(url, data).then(response => dispatch(actions.saveToBackendSuccessful(response.data)));
};

const acceptTransaction =
  (transaction, ignore_schedule_warnings = false) =>
  dispatch => {
    return respondToTransaction(transaction, 'accept', ignore_schedule_warnings)(dispatch);
  };

const rejectTransaction = transaction => dispatch => {
  return respondToTransaction(transaction, 'reject')(dispatch);
};

export default {
  fetch,
  acceptTransaction,
  rejectTransaction
};
